import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component } from '@angular/core';
import { LoginService } from './services/login/login.service';
import { Router } from '@angular/router';

import { MinisterService } from './services/minister/minister.service';
import { NotificationsService } from './services/notifications/notifications.service';
import { Notification } from './models/notification.model';
import { GeneralService } from './services/general/general.service';
import { IglesiasService } from './services/iglesias/iglesias.service';
import { Church } from './models/church.model';
import { UserService } from '@asambleas-services/user/user.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    // -----------------------------------------------------------------
    // ATTRIBUTES/ATRIBUTOS
    // -----------------------------------------------------------------
    title = 'Asambleas de Dios';

    isLogged: boolean = false
    showSideBar = false;
    showToolBar = false;
    sectionActive: string;
    optionActive: string;
    mobileQuery: MediaQueryList;

    private _mobileQueryListener: () => void;

    canPostulateMinister: boolean = true;
    quantityNotifications: number = 0;
    quantityPendingChurches: number = 0;

    user;
    highestRol: number;
    permissions: boolean[] = [];

    constructor(
        changeDetectorRef: ChangeDetectorRef,
        media: MediaMatcher,
        private loginService: LoginService,
        private router: Router,
        private ministerService: MinisterService,
        private _notificationsService: NotificationsService,
        public _generalService: GeneralService,
        private _iglesiasService: IglesiasService,
        private _userService: UserService
    ) {
        console.log('App Constructor')
        this.getUser();

        this.loginService.ingresoUsuario.subscribe((data) => {
            this.getUser();
            this.countNotifications();
            this.countPendingChurches();

            this.ministerService.getMinisterByUserId().subscribe((minister) => {
                // NO PUEDE POSTULAR A MINISTRO, YA QUE POSEE UN OBJETO MINISTRO (SOLO VALIDO PARA CUANDO POSTULAN A NIVEL 1 MINISTRO)
                this.canPostulateMinister = false;
            }, (error) => {
                this.canPostulateMinister = true;
            });
        })

        this.loginService.$obsLogged.subscribe(isLogged => {
            this.isLogged = isLogged
            this.showHideMenu()
            this.openOptionMenu()
        });

        this.mobileQuery = media.matchMedia('(max-width: 900px)');
        this._mobileQueryListener = () => {
            changeDetectorRef.detectChanges();
            this.showHideMenu()
            this.openOptionMenu()
        }
        this.mobileQuery.addListener(this._mobileQueryListener);
        this.showHideMenu()
        this.openOptionMenu()

        if (this._generalService.isLogged()) {
            this.countNotifications();
            this.countPendingChurches();
        }

        this._notificationsService.pendingChurchesEvent.subscribe((data) => {
            if (data) {
                this.countPendingChurches();
            }
        })

        this._notificationsService.notificacionWasRead.subscribe((data) => {
            if (data) {
                this.countNotifications();
            }
        });
    }

    getUser() {
        this.user = this.loginService.getUser();
        this._userService.createUser(this.user);
        //console.log('user', this.user);

        this.highestRol = this.loginService.getHighestRol();

        this.setPermissions(this.highestRol, this.loginService.getInfoRole() ? this.loginService.getInfoRole().id : null);

        console.log(this.loginService.getInfoRole());

    }

    setPermissions(rol: number, idRole: number = null) {

        switch (rol) {
            case 1:
                this.permissions['canManageMembers'] = true;
                this.permissions['camManageRoles'] = true;
                this.permissions['canLoadChurches'] = true;
                this.permissions['canSeePendingChurches'] = true;
                this.permissions['canSeeMinisterList'] = true;
                this.permissions['cannSeeCredentialRenovations'] = true;
                break;
            case 2:
                this.permissions['canManageMembers'] = true;
                this.permissions['camManageRoles'] = false;
                this.permissions['canLoadChurches'] = false;
                this.permissions['canSeePendingChurches'] = false;
                this.permissions['canSeeMinisterList'] = true;

                if (idRole && idRole == 3) {
                    this.permissions['cannSeeCredentialRenovations'] = true;
                }
                else {
                    this.permissions['cannSeeCredentialRenovations'] = false;
                }

                break;
            case 3:
                this.permissions['canManageMembers'] = false;
                this.permissions['camManageRoles'] = false;
                this.permissions['canLoadChurches'] = false;
                this.permissions['canSeePendingChurches'] = false;
                this.permissions['canSeeMinisterList'] = true;
                this.permissions['cannSeeCredentialRenovations'] = false;
                break;
            case 4:
                this.permissions['canManageMembers'] = false;
                this.permissions['camManageRoles'] = false;
                this.permissions['canLoadChurches'] = false;
                this.permissions['canSeePendingChurches'] = false;
                this.permissions['canSeeMinisterList'] = false;
                this.permissions['cannSeeCredentialRenovations'] = false;
                break;
            default:
                this.permissions['canManageMembers'] = false;
                this.permissions['camManageRoles'] = false;
                this.permissions['canLoadChurches'] = false;
                this.permissions['canSeePendingChurches'] = false;
                this.permissions['canSeeMinisterList'] = false;
                this.permissions['cannSeeCredentialRenovations'] = false;
        }

    }

    countNotifications() {
        this._notificationsService.getNotifications()
            .subscribe((data: Notification[]) => {
                this.quantityNotifications = data.length;
            })
    }

    countPendingChurches() {
        this._iglesiasService.getPendingChurches()
            .subscribe((data: Church[]) => {
                this.quantityPendingChurches = data.length;
            })
    }

    showHideMenu() {
        if (this.isLogged) {
            this.showToolBar = this.mobileQuery.matches
            this.showSideBar = !this.showToolBar
        } else {
            this.showToolBar = false
            this.showSideBar = false
        }
    }

    openOptionMenu() {
        setTimeout(() => {
            this.validOptionActive(this.router.url)
        }, 500)
    }

    validOptionActive(url) {
        switch (url) {
            // church
            case '/admin/church/lista':
                this.sectionActive = 'churches';
                this.optionActive = 'church-list';
                break;
            case '/admin/cargar-church-csv':
                this.sectionActive = 'churches';
                this.optionActive = 'church-upload';
                break;

            // miembros
            case '/admin/members/list':
                this.sectionActive = 'members';
                this.optionActive = 'members-list';
                break;
            case '/admin/members/masive-members-load':
                this.sectionActive = 'members';
                this.optionActive = 'members-upload';
                break;

            // extension
            case '/admin/extension/planter-list':
                this.sectionActive = 'extension';
                this.optionActive = 'planter-list';
                break;
            case '/admin/extension/planters-report':
                this.sectionActive = 'extension';
                this.optionActive = 'planters-report';
                break;
            case '/admin/extension/seeder-dash':
                this.sectionActive = 'extension';
                this.optionActive = 'seeder-dash';
                break;

            // ministros
            case '/admin/ministers/minister-list':
                this.sectionActive = 'ministers';
                this.optionActive = 'minister-list';
                break;

            default:
                this.sectionActive = '';
                this.optionActive = '';
                break;
        }
    }

    goToNotifications() {
        this.router.navigate(['admin', 'notifications']);
    }

    // Metodo que usa el sidenav
    ngOnDestroy(): void {
        this.mobileQuery.removeListener(this._mobileQueryListener);
    }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts